import { Typography } from '@/shared/ui';

import type { Sx } from '@/shared/types/uiTypes';

const PremiumFeatureMessage = ({ sx }: { sx?: Sx }) => (
  <>
    <Typography sx={sx}>This feature isn't included in your plan.</Typography>
    <Typography sx={sx}>Upgrade for advanced functionality.</Typography>
  </>
);

export default PremiumFeatureMessage;
